module.exports = __webpack_public_path__ + "img/award-bg-ms.9686efe8.png";